/**
 * InfoTooltip Component
 *
 * Elegant info icon with hover tooltip for field labels
 * Shows helpful context without cluttering the UI
 */

import { useState } from 'react';

export default function InfoTooltip({ text }) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      style={{
        position: 'relative',
        display: 'inline-block',
        marginLeft: '6px'
      }}
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {/* Info Icon */}
      <div
        style={{
          width: '18px',
          height: '18px',
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '12px',
          fontWeight: '700',
          cursor: 'help',
          transition: 'transform 0.2s',
          transform: isVisible ? 'scale(1.1)' : 'scale(1)'
        }}
      >
        i
      </div>

      {/* Tooltip Box */}
      {isVisible && (
        <div
          style={{
            position: 'absolute',
            bottom: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            marginBottom: '8px',
            padding: '12px 16px',
            background: 'white',
            border: '2px solid #667eea',
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(102, 126, 234, 0.2)',
            fontSize: '13px',
            lineHeight: '1.5',
            color: '#374151',
            minWidth: '280px',
            maxWidth: '360px',
            zIndex: 1000,
            animation: 'fadeInUp 0.2s ease-out',
            pointerEvents: 'none'
          }}
        >
          {/* Arrow */}
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              width: 0,
              height: 0,
              borderLeft: '8px solid transparent',
              borderRight: '8px solid transparent',
              borderTop: '8px solid #667eea'
            }}
          />
          <div
            style={{
              position: 'absolute',
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%) translateY(-2px)',
              width: 0,
              height: 0,
              borderLeft: '7px solid transparent',
              borderRight: '7px solid transparent',
              borderTop: '7px solid white'
            }}
          />

          {text}
        </div>
      )}

      {/* Animation */}
      <style>
        {`
          @keyframes fadeInUp {
            from {
              opacity: 0;
              transform: translateX(-50%) translateY(4px);
            }
            to {
              opacity: 1;
              transform: translateX(-50%) translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}
